export const blackTheme = {
  body: "#0b0b0c",
  text: "#e4dbdb",
  blue: "#e21c23",
  orange: "#33f033",
};

export const lightTheme = {
  body: "#ffffff",
  text: "#000000",
  blue: "#1179f7",
  orange: "#ffa500",
};

export const chosenTheme = blackTheme;
